<template>
  <section class="flex flex-col gap-12 items-center justify-center overflow-hidden px-4 py-16 relative w-full bg-white md:px-16">
    <div class="banner-cta w-full max-w-[1200px]">
      <div
        class="flex flex-col items-start justify-between gap-8 overflow-hidden rounded-3xl border border-gray-100 p-8 md:flex-row md:items-center md:gap-8 md:p-16"
        :style="{ background: bannerBackground }"
      >
        <div class="min-w-0 flex-1">
          <h3 class="text-[36px] font-semibold leading-[44px] tracking-[-0.02em] text-[#262626]">
            {{ headingText }}
          </h3>
          <p
            v-if="supportingText"
            class="mt-5 text-[18px] font-normal leading-7 text-[#262626]"
          >
            {{ supportingText }}
          </p>
        </div>
        <a
          v-if="buttonLabel"
          :href="buttonUrl || '#'"
          class="inline-flex h-12 shrink-0 items-center justify-center gap-2 rounded-lg border border-gray-200 bg-white px-5 py-[14px] text-[16px] font-medium text-[#374151] transition-colors hover:bg-gray-50"
        >
          {{ buttonLabel }}
          <svg
            class="size-5 shrink-0"
            viewBox="0 0 20 20"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M4.5 10H15.5M15.5 10L11 5.5M15.5 10L11 14.5"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </a>
      </div>
    </div>
  </section>

</template>

<script setup>
import { computed } from 'vue';
import { themeCardColorFor, themeBorderColorFor } from '@/utils/siteThemeColors';

const props = defineProps({
  headingText:    { type: String, default: '' },
  supportingText:   { type: String, default: '' },
  buttonLabel:      { type: String, default: '' },
  buttonUrl:        { type: String, default: '#' },
  // eslint-disable-next-line vue/prop-name-casing
  site_context:     { type: String, default: null },
});

// Uniform light-brand tint (Figma): a subtle same-hue gradient from the slightly
// stronger border tint into the lighter card tint — stays blue across the whole
// banner instead of fading out to white on the right.
const bannerBackground = computed(
  () => `linear-gradient(135deg, ${themeBorderColorFor(props.site_context)} 0%, ${themeCardColorFor(props.site_context)} 100%)`,
);
</script>
